import { render, staticRenderFns } from "./EventActionsMenu.vue?vue&type=template&id=178cf958&scoped=true"
import script from "./EventActionsMenu.vue?vue&type=script&lang=js"
export * from "./EventActionsMenu.vue?vue&type=script&lang=js"
import style0 from "./EventActionsMenu.vue?vue&type=style&index=0&id=178cf958&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178cf958",
  null
  
)

export default component.exports